// extracted by mini-css-extract-plugin
export default {"forgotPassword":"forgotPassword_forgotPassword__e+A16","successText":"forgotPassword_successText__qNWLe"};